@if (isExpanded) {
<div class="overlay" (click)="toggleDrawer()"></div>
}

@if (budgetList.length) {
<div class="drawer" [class.expanded]="isExpanded">
  @if (hasOnlinePayment()) {
  <app-ui-budget-banner [hasOnRequest]="hasOnRequest()" (openModal)="openModal.emit($event)">
    <ng-content onRequest select="[onRequest]" />
    <ng-content onRequest-action select="[onRequest-action]" />
  </app-ui-budget-banner>
  }
  <div (click)="toggleDrawer()" class="toggle-arrow" [class.expanded]="isExpanded">
    <img src="../assets/lib/icons/Icon_Arrow.svg" alt="Arrow" />
  </div>

  <div class="drawer-wrapper">
    <div class="drawer-wrapper__content">
      <app-ui-budget-total [hasOnlinePayment]="hasOnlinePayment()" [total]="total()" [oldTotal]="oldTotal()" [totalSubtitle]="totalSubtitle()">
        <ng-content title-total select="[title-total]" />
        <ng-content label-total select="[label-total]" />
      </app-ui-budget-total>

      @if (isExpanded) {
      <div class="drawer-itens">
        @for (budget of budgetList; track budget.description) {
        <app-ui-budget-item [item]="budget" />
        }

        @if (discountList.length) {
        <div class="discounts-title">
          <ng-content select="[title-discounts]" />
        </div>
        }

        @for (discount of discountList; track discount.description; let last = $last) {
        <app-ui-budget-item [item]="discount" [isLast]="last && !alreadyPaidItem()" />
        }
        @if (alreadyPaidItem()) {
        <app-ui-budget-item [item]="alreadyPaidItem()!" [isLast]="true" />
        }
      </div>
      }
    </div>
  </div>
</div>
}
